"use strict";

var _createClass = require("C:\\Matiria\\GitHub2\\Website\\FyatLuxCycles\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _classCallCheck = require("C:\\Matiria\\GitHub2\\Website\\FyatLuxCycles\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletLinkAnalyticsAbstract = void 0;
/**
 * An abstract class used to send events to track metrics / analytics
 */

var WalletLinkAnalyticsAbstract = /*#__PURE__*/_createClass(function WalletLinkAnalyticsAbstract() {
  _classCallCheck(this, WalletLinkAnalyticsAbstract);
});

exports.WalletLinkAnalyticsAbstract = WalletLinkAnalyticsAbstract;